import React, { createRef } from 'react';
import { createRoot } from 'react-dom/client';
import HekateDocumentViewer from './HekateDocumentViewer';
window.mountHekateDocumentViewer = function mountHekateDocumentViewer(containerId, props) {
    const container = document.getElementById(containerId);
    if (!container) {
        console.error('HekateDocumentViewer: container not found:', containerId);
        return {
            type: 'document',
            unmount: () => { },
            get api() { return null; },
        };
    }
    const apiRef = createRef();
    const root = createRoot(container);
    root.render(React.createElement(HekateDocumentViewer, { ...props, ref: apiRef }));
    return {
        type: 'document',
        unmount: () => root.unmount(),
        get api() { return apiRef.current; },
    };
};
